import PropTypes from 'prop-types';
import MuiTypography from '@mui/material/Typography';
import { themeColors } from '../theme/theme';
import { useTranslation } from './useTranslation';

// Use MUI's default font sizes for variants
const variantMap = {
  h1: 'h4', // MUI h4 is visually large for mobile
  h2: 'h5',
  h3: 'h6',
  text: 'body1',
  subtitle: 'subtitle1',
};

export function Typography({
  text,
  type = 'text',
  color,
  variant,
  fontWeight,
  style,
  children,
  ...rest
}) {
  const { t, language } = useTranslation();
  const translatedText = typeof text === 'string' ? t(text) : text;
  const muiVariant = variant || variantMap[type] || 'body1';
  const resolvedColor =
    color ?? (type.startsWith('h') ? themeColors.headersColor : themeColors.textColor);
  const resolvedFontWeight = fontWeight || (type.startsWith('h') ? 600 : 400);

  return (
    <MuiTypography
      variant={muiVariant}
      lang={language}
      style={{
        color: resolvedColor,
        fontWeight: resolvedFontWeight,
        fontFamily: themeColors.fontFamily,
        margin: 0,
        ...style,
      }}
      {...rest}
    >
      {text !== undefined && text !== null ? translatedText : children}
    </MuiTypography>
  );
}

Typography.propTypes = {
  text: PropTypes.node,
  type: PropTypes.oneOf(['h1', 'h2', 'h3', 'text', 'subtitle']),
  color: PropTypes.string,
  variant: PropTypes.string,
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
  children: PropTypes.node,
};
